import { defineStore } from 'pinia';
import ApiService from '@common/services/api.service';

type MenuItem = {
    icon: string;
    title: string;
    to: string;
    children?: MenuItem[];
}

export const baseMenuStore = {
    state: () => ({
        menu: JSON.parse(localStorage.getItem('menu') || 'null') as MenuItem[] | null
    }),
    actions: {
        async chargerMenu() {
            if (this.menu !== null) {
                //return;
            }

            try {
                const response = await ApiService.get<MenuItem[]>('/api/menus');
                this.menu = response.data;
                localStorage.setItem('menu', JSON.stringify(this.menu));
            } catch (error) {
                console.error('Menu failed:', error);
            }
        },

        viderMenu() {
            this.menu = null;
            localStorage.removeItem('menu');
        }
    },
}


export const useMenuStore = defineStore('menu', {
    state: baseMenuStore.state,
    actions: baseMenuStore.actions,
});
